/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchInventoriesDownload,
  useInventoryList,
} from "../../../../api/inventory/use-inventory";
import { FallbackImage } from "../../../../assets/img";
import Modal from "../../../../components/ui/Modal/Modal";
import Table from "../../../../components/ui/Table/Table";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productGroup?.productNo, {
      header: "상품번호",
      cell: (info) => {
        const val = info.getValue();
        const prodNo = val?.length > 10 ? val?.substring(0, 10) + "..." : val;

        return <div>{val ? prodNo : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.productGroup.mainImage, {
      header: "이미지",
      cell: (info) => {
        let val = info.getValue();
        const handleError = ({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = FallbackImage;
        };
        return (
          <div className="m-auto w-[100px] h-[100px] flex justify-center">
            <img
              className="m-auto w-[85px] h-[85px] border border-primary-grey object-cover"
              src={val}
              onError={handleError}
            />
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.productGroup?.productGroupCategory, {
      header: "카테고리",
      cell: (info) => {
        const val = info.getValue().name;
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "상품 그룹명/상품명",
      cell: (info) => {
        const name = info.getValue().name;
        const productGroup = info.getValue().productGroup.name;
        const prodNameSliced =
          name?.length > 20 ? name?.substring(0, 20) + "..." : name;
        const prodGroupSliced =
          productGroup?.length > 20
            ? productGroup?.substring(0, 20) + "..."
            : productGroup;

        return (
          <>
            <span className="text-[#333333]">{prodGroupSliced}</span>
            <br />
            <span className="text-[#aaaaaa]">{prodNameSliced}</span>
          </>
        );
      },
    }),

    columnHelper.accessor((row) => row?.ref, {
      header: "REF(상품코드)",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.inventoryQnt, {
      header: "총 재고수량",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val}</div>;
      },
    }),

    columnHelper.display({
      header: "관리",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      // onClick={() => navigate(`detail`)}
      onClick={() => navigate(`${id}`)}
      className="w-12 p-[3px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function InventoryTable(props) {
  const { filter, sort, onClose } = props;
  const { isEmpty, getDataTableProps } = useInventoryList(filter, sort);
  const [tableData, setTableData] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(
    getDataTableProps().pagination?.pageIndex + 1
  );
  const [pageSize, setPageSize] = React.useState(
    getDataTableProps().pagination?.pageSize
  );
  const [totalData, setTotalData] = React.useState(getDataTableProps().total);
  const [pageCount, setPageCount] = React.useState(
    getDataTableProps().pageCount
  );
  const [isEmptyResult, setIsEmptyResult] = React.useState(false);

  const onSave = async () => {
    await fetchInventoriesDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `inventory-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  React.useEffect(() => {
    if (isEmpty) {
      setIsEmptyResult(true);
    } else {
      setIsEmptyResult(false);
    }
  }, [isEmpty]);

  React.useEffect(() => {
    if (!isEmpty) {
      setTableData(getDataTableProps()?.data);
      setCurrentPage(getDataTableProps()?.pagination?.pageIndex + 1);
      setPageSize(getDataTableProps().pagination?.pageSize);
      setTotalData(getDataTableProps().total);
      setPageCount(getDataTableProps().pageCount);
    }
  }, [getDataTableProps()]);

  return (
    <div className="mt-8">
      <Table
        {...getDataTableProps()}
        onSave={onSave}
        hasPageSizeFilter={false}
        hasSort={false}
        columns={columns(currentPage, pageSize, totalData)}
        data={tableData}
        pageCount={pageCount}
      />
      {isEmptyResult && (
        <Modal
          isOpenFromOutside={isEmptyResult}
          setIsOpenFromOutside={setIsEmptyResult}
          description="검색결과가 없습니다."
          hasCancel={false}
          onClose={onClose}
          onSubmit={onClose}
        />
      )}
    </div>
  );
}
